import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import { IconButton } from "atoms/icon-button/IconButton";

type Props = {
  className?: string;
  /** Explicit previous route; when provided, back button will navigate here */
  prev?: string;
};

/**
 * Placeholder component to maintain header spacing when back button is hidden
 */
export const OnboardingBackButtonPlaceholder = ({ className }: { className?: string }) => {
  return <div className={`flex items-center px-3 pb-0 pt-4 ${className || ""}`} />;
};

export const OnboardingBackButton = ({ className, prev }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (prev) {
      navigate(prev);
      return;
    }
    navigate(-1);
  };

  return (
    <div className={`flex items-center px-3 pb-0 pt-4 ${className || ""}`}>
      <IconButton
        svg={ChevronLeft}
        size="small"
        style="iconOnly"
        onClick={handleClick}
        aria-label={t("onboardingBackButton.goBack")}
      />
    </div>
  );
};

export default OnboardingBackButton;
